export const DEFAULT_ORDER_ITEMS_PER_PAGE = 30;
export const ALL_ERRORS_COPY = "All errors";
